<template>
  <div>
    <b-card>
      <div class="text-right mb-3">
        <exporter grid-ref="theGrid" :url="'stars/exportwsobjectives'">
        </exporter>
        <router-link class="btn btn-primary" :to="{ name: 'ws_objectives.import' }"><i class="fa fa-plus"></i>
          Importar</router-link>
        <router-link class="btn btn-primary" :to="{ name: 'ws_objectives.create' }"><i class="fa fa-plus"></i>
          Criar</router-link>
      </div>
      <grid-filters grid-data="theGrid" :fields="gridFilters"></grid-filters>
      <Grid ref="theGrid" name="wsObjectivesGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns"
        :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
    </b-card>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'wsObjectivesGrid',
  components: {
    Grid
  },
  data() {
    return {
      gridFilters: [],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'updated_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      preload: [],
      url: 'stars/ws_objectives',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'ym',
        title: 'Ano/Mês',
        width: '120px'
      },
      {
        field: 'zone',
        title: 'Zona',
        width: '120px'
      },
      {
        field: 'obj_operators',
        title: 'Operadores',
        width: '120px'
      },
      {
        field: 'obj_sumtop10',
        title: 'SumTop10',
        width: '120px'
      },
      {
        field: 'obj_webshop',
        title: 'Webshop',
        width: '120px'
      },
      {
        field: 'obj_ufs',
        title: 'UFS',
        width: '120px'
      },
      {
        field: 'obj_spreads',
        title: 'Spreads',
        width: '120px'
      },
      {
        field: 'obj_nps_top10_ufs',
        title: 'NPS Top10 UFS',
        width: '120px'
      },
      {
        field: 'obj_nps_top10_spreads',
        title: 'NPS Top10 Spreads',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function (element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      },
      {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function (element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function (item) {
      var route = router.resolve({
        name: 'ws_objectives.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('ws_objectives.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
